export const COMPTA_PRICE = 399;

export const TVA_RATES = [
  { value: 2.1, label: "2.1%" },
  { value: 5.5, label: "5.5%" },
  { value: 8.5, label: "8.5%" },
  { value: 10, label: "10%" },
  { value: 20, label: "20%" },
];
